import { PropsWithChildren } from 'react';
import { Loading } from '../../../hooks/useLoading';
import { useCourses, useCoursesInitialized } from '../../../hooks/useCourses';

const LearningDataGate: React.FC<PropsWithChildren> = ({ children }) => {
  // Subscribe to the courses cache to trigger its lazy load.
  useCourses();
  const coursesInitialized = useCoursesInitialized();

  if (!coursesInitialized) {
    return <Loading />;
  }

  return <>{children}</>;
};

export default LearningDataGate;
